<template>
    <span
        style="display: inline-flex; align-items: center; justify-content: center; height: 24px; min-width: 24px; border-radius: 9999px;"
        :style="{'background-color': color}"
    >
        <span style="font-size: 12px; line-height: 16px; font-weight: 500; color: rgb(255 255 255); padding: 0 4px;">
           <slot/>
        </span>
    </span>
</template>

<script>
export default {
    props: {
        color: {
            required: true
        }
    }
}
</script>
